import PropTypes from 'prop-types';
import React from 'react';

const Spacer = props =>
  <div style={{ marginBottom: `${props.size}rem` }} />;

Spacer.propTypes = {
  size: PropTypes.number,
};

module.exports = Spacer;



// WEBPACK FOOTER //
// ./app/components/common/spacer/Spacer.jsx